export default {
  mapRightClick: {
    options: 'Opções',
    addDestinationToRoute: 'Adicionar como destino',
    directionsFromHere: 'Direções daqui',
    directionsToHere: 'Direções para aqui',
    nonStopDirectionsToHere: 'Direto para aqui',
    addRouteStop: 'Adicionar parada aqui',
    centerHere: 'Centralizar aqui',
    addAsIsochroneCenter: 'Adic. como centro de isócrono',
    inspectDataOnOSM: 'Ver dados no OSM'
  }
}
